// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let Scalars = require("../../../scalars/Scalars.bs.js");
let TanDate = require("../../../reason/common/types/TanDate.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsListItemContext = require("./ConversationsListItemContext.bs.js");
let ConversationsListItemParticipants = require("./ConversationsListItemParticipants.bs.js");
let ConversationsListItem_lastMessage_graphql = require("../../../__generated__/ConversationsListItem_lastMessage_graphql.bs.js");
let ConversationsListItem_conversation_graphql = require("../../../__generated__/ConversationsListItem_conversation_graphql.bs.js");
let ConversationPageExistingConversationQuery_graphql = require("../../../__generated__/ConversationPageExistingConversationQuery_graphql.bs.js");

let convertFragment = ConversationsListItem_lastMessage_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItem_lastMessage_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItem_lastMessage_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsListItem_lastMessage_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItem_lastMessage_graphql.node, convertFragment, fRef);
}

let LastMessageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = ConversationsListItem_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItem_conversation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItem_conversation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsListItem_conversation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItem_conversation_graphql.node, convertFragment$1, fRef);
}

let ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function formatRelativeToNow(date) {
  let days = DateFns.differenceInCalendarDays(date, TanDate.now());
  return (
    days !== 0 ? (
        days !== 1 ? (
            days < 365 ? DateFns.format(date, "eee M/d") : DateFns.format(date, "M/d/yyyy")
          ) : "Yesterday"
      ) : DateFns.format(date, "h:mm aa")
  ).replace(" ", Utils.$$String.nbsp);
}

function ConversationsListItem(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationsListItem_conversation_graphql.node, convertFragment$1, props.conversation);
  let lastMessage = RescriptRelay_Fragment.useFragment(ConversationsListItem_lastMessage_graphql.node, convertFragment, conversation.lastMessage.fragmentRefs);
  let agent = UserSession.useAgentInfo();
  let hoverRef = React.useRef(undefined);
  React.useEffect(() => (() => {
    let timeoutId = hoverRef.current;
    if (timeoutId !== undefined) {
      clearTimeout(Primitive_option.valFromOption(timeoutId));
      return;
    }
  }), [hoverRef]);
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let participants = Stdlib_Array.keepSome(Stdlib_Option.getOr(Stdlib_Option.map(conversation.participantNames, p => p.edges), [])).map(v => v.node).filter(v => {
    switch (v.__typename) {
      case "Agent" :
        return v.id !== agent.id;
      case "AnonymousConversationParticipant" :
      case "__unselected" :
        return true;
    }
  });
  let match = conversation.unreadMessages;
  let unreadMessages = match !== undefined ? match.totalCount : 0;
  let match$1 = lastMessage.from;
  let senderIsUser = match$1 !== undefined && match$1.__typename === "Agent" ? match$1.id === agent.id : false;
  let participantNames = Stdlib_Array.filterMap(participants, p => {
    switch (p.__typename) {
      case "Agent" :
        return p.displayName;
      case "AnonymousConversationParticipant" :
        return "A TAN agent";
      case "__unselected" :
        return;
    }
  }).join(", ");
  let tmp;
  if (senderIsUser) {
    let match$2 = lastMessage.files;
    let exit = 0;
    if (match$2 !== undefined) {
      let totalCount = match$2.totalCount;
      if (totalCount > 0) {
        tmp = `Sent ` + totalCount.toString() + ` files`;
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      let match$3 = lastMessage.images;
      if (match$3 !== undefined) {
        let totalCount$1 = match$3.totalCount;
        tmp = totalCount$1 > 0 ? `Sent ` + totalCount$1.toString() + ` images` : "You: " + Stdlib_Option.getOr(lastMessage.text, "");
      } else {
        tmp = "You: " + Stdlib_Option.getOr(lastMessage.text, "");
      }
    }
  } else {
    let match$4 = lastMessage.files;
    let exit$1 = 0;
    if (match$4 !== undefined) {
      let totalCount$2 = match$4.totalCount;
      if (totalCount$2 > 0) {
        tmp = `Received ` + totalCount$2.toString() + ` files`;
      } else {
        exit$1 = 1;
      }
    } else {
      exit$1 = 1;
    }
    if (exit$1 === 1) {
      let match$5 = lastMessage.images;
      if (match$5 !== undefined) {
        let totalCount$3 = match$5.totalCount;
        tmp = totalCount$3 > 0 ? `Received ` + totalCount$3.toString() + ` images` : Stdlib_Option.getOr(lastMessage.text, "");
      } else {
        tmp = Stdlib_Option.getOr(lastMessage.text, "");
      }
    }
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationsListItemParticipants.make, {
          conversation: conversation.fragmentRefs,
          showNames: false
        }),
        className: "p-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: participantNames,
            className: "font-semibold line-clamp-1",
            title: participantNames
          }),
          JsxRuntime.jsx("div", {
            children: tmp,
            className: "line-clamp-1"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ConversationsListItemContext.make, {
              conversation: conversation.fragmentRefs
            }),
            className: "my-2"
          })
        ],
        className: "py-2 flex-1"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: unreadMessages !== 0 ? JsxRuntime.jsx("div", {
                children: unreadMessages,
                className: "rounded-full bg-tan-gold text-white w-5 h-5 flex flex-col items-center justify-center text-sm font-semibold"
              }) : null,
            className: "self-end"
          }),
          JsxRuntime.jsx("div", {
            children: formatRelativeToNow(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(lastMessage.sentAt))),
            className: "text-sm"
          })
        ],
        className: "py-2 pr-2 flex flex-col space-y-0.5"
      })
    ],
    className: "flex flex-row",
    onMouseEnter: param => {
      let timeoutId = hoverRef.current;
      if (timeoutId !== undefined) {
        clearTimeout(Primitive_option.valFromOption(timeoutId));
      }
      hoverRef.current = Primitive_option.some(setTimeout(() => {
        ConversationPageExistingConversationQuery_graphql.load(environment, {
          id: conversation.id
        }, undefined, undefined, undefined);
      }, 200));
    },
    onMouseLeave: param => {
      let timeoutId = hoverRef.current;
      if (timeoutId !== undefined) {
        clearTimeout(Primitive_option.valFromOption(timeoutId));
        return;
      }
    }
  });
}

let make = ConversationsListItem;

exports.LastMessageFragment = LastMessageFragment;
exports.ConversationFragment = ConversationFragment;
exports.formatRelativeToNow = formatRelativeToNow;
exports.make = make;
/* Utils Not a pure module */
